// extracted by mini-css-extract-plugin
module.exports = {"blogPosts":"blog_blogPosts__2X31t","listEntry":"blog_listEntry__1zKgv"};